module.exports = __webpack_public_path__ + "static/media/dormitorio-secundario.06c6c5a0.jpg";